export const PATH_STUDENTS = 'students';
export const PATH_STUDENTS_LIST = 'list';
export const PATH_ASSIGN_PATIENTS = 'assign-patients';
export const PATH_VIEW_STUDENT_PATIENT = 'view';
export const PATH_ID_PARAM = 'id';
